/** Canal temporal para Andrea. Firebase lo borra a los 15 días; la página también se apaga. */
export const SKILLSYNC_SHARE_CHANNEL = 'revision-andrea';
export const SKILLSYNC_SHARE_EXPIRES_AT = '2026-11-07T23:59:59-06:00';
export const SKILLSYNC_SHARE_EXPIRES_LABEL = '7 de noviembre de 2026';

/** Solo estas cuentas abren el enlace publicado. */
export const SKILLSYNC_SHARE_EMAILS = [
  'christian@plexarian.com',
  'andreag@plexarian.com',
];

export function canOpenSkillsyncShare(email) {
  const normalized = String(email || '').toLowerCase().trim();
  return SKILLSYNC_SHARE_EMAILS.includes(normalized);
}

export function isSkillsyncShareHost(hostname) {
  const host = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
  return String(host).includes(SKILLSYNC_SHARE_CHANNEL);
}

export function isSkillsyncShareExpired(now = Date.now()) {
  if (!isSkillsyncShareHost()) return false;
  return now > new Date(SKILLSYNC_SHARE_EXPIRES_AT).getTime();
}
